import axiosClient from "./AxiosConfig";

const AuditService = {

  async postFilteredLogs(filter, page, size) {
    return await axiosClient.post("/admin/get-audit-logs", filter, {
      params: { page, size }
    });
  }
};

export default AuditService;
